export default "__VITE_ASSET__46dd6508__"